import React, { useEffect, useState } from "react";
import { ClientApiProps } from "../../common";
import { Client, ISettings, ISettingsBase, getApiClient } from "../../api";
import { Label, Select } from "acma-spa";
import { SettingsStore } from "../../stores/SettingsStore";
import { SettingsDetails } from "./SettingsDetails";

export interface SettingsProps extends ClientApiProps {
  settings: ISettings[]
  onSettings: (settings: ISettings[]) => any
  onSpinner: (text: string) => any
}

export const SettingsPage: React.FC<SettingsProps> = (props) => {
  const [current, setCurrent] = useState<string | null>(null);

  useEffect(() => {
    if (props.settings.length == 1)
      setCurrent(props.settings[0].clientId ?? null);
  }, [props.settings])

  const currentSettings = props.settings.filter(r => r.clientId == current)[0];

  const onUpdate = (update: ISettings) => {
    var newSettings = props.settings.slice();
    var index = newSettings.findIndex(r => r.clientId == update.clientId);
    console.log(update, index);
    if (index >= 0) {
      newSettings.splice(index, 1, update);
    }
    props.onSettings(newSettings);
  }

  return <>
    {props.settings.length > 1 ? <Label label="Company" required id="company">
      <Select
        options={props.settings.map(r => ({ label: r.clientName!, value: r.clientId! }))}
        value={current}
        onChange={v => setCurrent(v)}
        defaultLabel="Select..."
      />
    </Label> : <></>}
    {currentSettings ? <SettingsDetails
      {...props}
      settings={currentSettings ?? {}}
      key={currentSettings?.clientId}
      onSettings={onUpdate}
    /> : <></>}
  </>
}